import confirm from './confirm';
import IPosModal from './IPosModal';
import AddItemModal from './AddItemModal';
import ConfirmModal from './ConfirmModal';
import AlertModal from './AlertModal';
import BranchInfoModal from './BranchInfoModal';
import BranchesListModal from './BranchesListModal';
import ConfirmationCodeModal from './ConfirmationCodeModal';
import PizzaPartModal from './PizzaPartModal';
import AdModal from './AdModal';
import AdImageModal from './AdImageModal';
import TipsModal from './TipsModal';
import ChooseDeliveryTime from './ChooseDeliveryTime';
import OrderBLItemTest from '../components/OrderBLItemTest';

IPosModal.addItemModal = (props, baseModalProps = {}) => {
  baseModalProps.modalClassName = 'add-item-modal';
  const config = {
    modalType: AddItemModal,
    modalProps: props,
    ...baseModalProps,
  };
  return confirm(config);
};

IPosModal.testModal = (props, baseModalProps = {}) => {
  baseModalProps.modalClassName = 'test-modal';
  const config = {
    modalType: OrderBLItemTest,
    modalProps: props,
    ...baseModalProps,
  };
  return confirm(config);
};

IPosModal.confirmation = (props, baseModalProps = {}) => {
  baseModalProps.modalClassName = 'confirmation-modal';
  const config = {
    modalType: ConfirmModal,
    modalProps: props,
    ...baseModalProps
  };
  return confirm(config);
};

IPosModal.alert = (props, baseModalProps = {}) => {
  if (!baseModalProps.modalClassName) {
    baseModalProps.modalClassName = 'alert-modal';
  }
  const config = {
    modalType: AlertModal,
    modalProps: props,
    ...baseModalProps
  };
  return confirm(config);
};

IPosModal.branchInfo = (props, baseModalProps = {}) => {
  baseModalProps.modalClassName = 'branch-info-modal';
  const config = {
    modalType: BranchInfoModal,
    modalProps: props,
    ...baseModalProps
  };
  return confirm(config);
};

IPosModal.branchesList = (props, baseModalProps = {}) => {
  baseModalProps.modalClassName = 'branches-list-modal';
  const config = {
    modalType: BranchesListModal,
    modalProps: props,
    ...baseModalProps
  };
  return confirm(config);
};

IPosModal.confirmationCode = (props, baseModalProps = {}) => {
  baseModalProps.modalClassName = 'confirmation-code-modal';
  const config = {
    modalType: ConfirmationCodeModal,
    modalProps: props,
    ...baseModalProps
  };
  return confirm(config);
};

IPosModal.pizzaPart = (props, baseModalProps = {}) => {
  baseModalProps.modalClassName = 'pizza-part-modal';
  const config = {
    modalType: PizzaPartModal,
    modalProps: props,
    ...baseModalProps
  };
  return confirm(config);
};

IPosModal.adModal = (props, baseModalProps = {}) => {
  baseModalProps.modalClassName = 'ad-modal';
  const config = {
    modalType: AdModal,
    modalProps: props,
    ...baseModalProps
  };
  return confirm(config);
};

IPosModal.adImageModal = (props, baseModalProps = {}) => {
  baseModalProps.modalClassName = 'ad-image-modal';
  const config = {
    modalType: AdImageModal,
    modalProps: props,
    ...baseModalProps
  };
  return confirm(config);
};

IPosModal.tipsModal = (props, baseModalProps = {}) => {
  baseModalProps.modalClassName = 'tips-modal';
  const config = {
    modalType: TipsModal,
    modalProps: props,
    ...baseModalProps
  };
  return confirm(config);
};

IPosModal.chooseTimeModal = (props, baseModalProps = {}) => {
  baseModalProps.modalClassName = 'choose-datetime-modal';
  const config = {
    modalType: ChooseDeliveryTime,
    modalProps: props,
    ...baseModalProps
  };
  return confirm(config);
};

export default IPosModal;
